import { Mouvement } from "../../common/models/mouvement.js";
import * as TerrassorConst from '../../terrassor_const.js'
import {TerrassorMessages} from './simulator-messages.js'
//import { SIMU_ETUDE } from "../../common/models/simu/SimuObj.js";

import { set_Terrassor_INTERFACE, get_Terrassor_INTERFACE, Terrassor_RECALCULATE } from "../../interface.js"; 
import { NWfunctionCheck, NWCheck, NWcopyUserDataFile, NWwriteFile, NWresetTerrassor, NWreloadTerrassor, NWgetUserTempDataFilePath, NWgetUserDataFilePath, NWgetMacDataFilePath } from '../../nw/NWfunctions.js'

import dateFns from 'date-fns'


/* @ngInject */
export class SimulatorController {
  /* @ngInject */
  constructor(ApiConst, ApiSimu, ApiExo, TerrassorDB, $location, $filter, $q, $timeout, FileDialog, FileDialogA, FileDialogB, FileDialogC, $scope) {

    this.ApiConst = ApiConst;
    this.ApiSimu = ApiSimu;
    this.ApiExo = ApiExo;
    this.TerrassorDB = TerrassorDB;
    this.$location = $location;
    this.$filter = $filter;
    this.$q = $q;
    this.$timeout = $timeout
    this.FileDialog = FileDialog
    this.FileDialogA = FileDialogA
    this.FileDialogB = FileDialogB
    this.FileDialogC = FileDialogC
    this.$scope = $scope
    this.codeEtude =""
    /*this.toggleDone = 0*/

    // les méthodes ci-dessous peuvent être appelées par des controlleurs child (via une liaison bind ou require)
    this.setCurrentMouvementByCode = this.setCurrentMouvementByCode.bind(this)
    this.setCurrentCubatureByCode = this.setCurrentCubatureByCode.bind(this)
    this.checkAllMouvementsValid = this.checkAllMouvementsValid.bind(this)
    this.isMouvementValid = this.isMouvementValid.bind(this)

    this.setPropertiesForPanelChantier = this.setPropertiesForPanelChantier.bind(this)

    this.SIMU_ETUDE = {}

    this.nbJoursAtteints = 0

    this.analyseContent = ''
    this.analyseBilan = ''
    this.analyseBilanSousTitreQSE = ''
    this.analyseBilanQSE = ''
    this.bilanContent = ''

    this.hasInstallation = false

    this.currentMouvementStarted = false

        this.svgEpure = null
    //    this.svgEpureCreer = null

    this.errorMessage = {"context":null, "message": null}

    this.modalDialogIsVisible = false
    this.lock=false
    this.lockable=true

      if (TerrassorConst.codeEtude) { // BC 2018/02
          this.codeEtude = TerrassorConst.codeEtude;
          }
    //  this.simulationEnMarche = 0

      // par défaut
    this.mode_utilisation = TerrassorConst.MODE_UTILISATION;
    if (this.mode_utilisation == TerrassorConst.MODE_SIMULATEUR) {
        this.etape_epure = TerrassorConst.ETAPE_SIMULATION;
        this.etape_epure_atteinte = TerrassorConst.ETAPE_SIMULATION;
    }
      else {
        this.etape_epure = 0;
        this.etape_epure_atteinte = 0;
      }
  }

/*
*/
  lancerSVG(validation)
  {
    //Terrassor_RECALCULATE() // le recalcul est déjà intégré à lancerSVG
//    var retour = get_Terrassor_INTERFACE().lancerSVG(this.nbJoursAtteints+1, validation)
    var retour = get_Terrassor_INTERFACE().lancerSVG(this.nbJoursAtteints, validation)
    console.log('lancerSVG', retour)    

    if ((typeof(retour.objet) != 'undefined') && (typeof(retour.objet.jourAtteint) != 'undefined') && (typeof(retour.objet.jourFinReel) != 'undefined')) {
        var etude = retour.objet;
        if (etude.jourAtteint < etude.jourFinReel) {
            this.lock=true;
            var tableauDeBord = new Object();
            tableauDeBord.lock = this.lock;
            etude.tableauDeBord = tableauDeBord;
        }
        else {
            this.lockable=false;
        }
    }

    return retour
  }
  lancerAGENDA()
  {
 //   var retour = get_Terrassor_INTERFACE().lancerAGENDA(this.nbJoursAtteints+1)
    var retour = get_Terrassor_INTERFACE().lancerAGENDA(this.nbJoursAtteints)
    console.log('lancerAGENDA', retour)
    return retour
  }
  lancerBILANFINANCIER()
  {
    var retour = get_Terrassor_INTERFACE().lancerBILANFINANCIER()
    console.log('lancerBILANFINANCIER')
    return retour
  }
  lancerBILANRESUME()
  {
    var retour = get_Terrassor_INTERFACE().lancerBILANRESUME()
    console.log('lancerBILANRESUME', retour)
    return retour
  }
  archiverBILAN()
  {
    console.log('archiverBILAN')
    return(this.printDataFile(1));
  }

    /*
  testerSimulationEnMarche()
  {
    var retour = get_Terrassor_INTERFACE().testerSimulationEnMarche()
    this.simulationEnMarche = retour
    console.log('testerSimulationEnMarche', retour)
    return retour
  }
*/
  // init du simulateur
  $onInit() {

    console.log('SimulatorController : init')

    console.log(this.FileDialog)

    // titre de l'appli  
    this.title = "Planification du chantier";

    // INfos du panel chantier
    this.parametresChantier = [];
    this.parametresSimulateur = [];
    this.previsionnelChantier = [];

    // propriétés utilisées pour l'état des mouvements dans <schema-cubatures> et pour le toggle du panel <animation>  
    this.validMouvements = []
    this.allMouvementsValid = false
    this.nbMouvementsChantier =  0

    this.installationValid = false
    this.installationData = null

    this.animationIsPlaying = false

      // visualisations
    this.epureVisible = true
    this.chargementChantierVisible = true
    this.chargementEtudeVisible = true
    this.chargementExamenVisible = false

    this.debug = TerrassorConst.MODE_DEBUG

    this.analyseContent = ''
    this.analyseBilan = ''
    this.bilanContent = ''

    // jQuery supporte le code de Bruno  
    if(!jQuery)
        console.log('jQuery required for INTERFACE')


      // BC 2019/02 : init des données simulateur
    this.constantesSimulateur = this.ApiConst.getConstantesSimulateur()
    this.setPropertiesSimulateurForPanelChantier();

      // BC 2019/04 : pour appel en dehors du $onInit()
    this.ApiSimu.getSimuAnalyse()
        .then(resultArray => {
            var analyses = resultArray.pop();
            this.initialiserSelonAnalyse(analyses);
        })
  }


    /*
    * Permet l'affichage en mode création d'épure ou en mode simulateur
    */
    initialiserSelonAnalyse(analyses) {

//console.log('initialiserSelonAnalyse : mode_utilisation', analyses.mode_utilisation)

    // BC 2019 - gestion des modes (dont examen)

            if(analyses && (typeof(analyses.mode_utilisation) != 'undefined') ) {
                if ((TerrassorConst.MODE_UTILISATION == TerrassorConst.MODE_EXAMEN) || (TerrassorConst.MODE_UTILISATION == TerrassorConst.MODE_EPURE)) {
                    analyses.mode_utilisation = TerrassorConst.MODE_UTILISATION; // on force toujours
                }
                this.mode_utilisation = analyses.mode_utilisation
                this.etape_epure = analyses.etape_epure
                this.etape_epure_atteinte = analyses.etape_epure_atteinte
            }

console.log('initialiserSelonAnalyse avant autoriserVisualisations')
            this.autoriserVisualisations();

            // "encapsulation" des outils de l'interface
            set_Terrassor_INTERFACE(new(INTERFACE))    // accessibilité par une globale (cd. Terrassor_INTERFACE) in interface.js


            if (!this.epureVisible) {
console.log('initialiserSelonAnalyse : !epureVisible')
                this.currentChantier = new Object();
                this.currentChantier.nom = "Saisie des paramètres du chantier"
                this.sendDBConstToInterface() // init de la session "interface" PARTIELLE avec les valeurs stockées en base

console.log('initialiserSelonAnalyse avant $timeout')
                this.$timeout(() => {this.$scope.$apply()}, 500);

                return; // pn ne va pas plus loin
                }
            else {
console.log('initialiserSelonAnalyse : epureVisible')
                this.sendDBDataToInterface() // init de la session "interface" avec les valeurs stockées en base
                // this.initEtapeEpure(); je pense que ça doit être fait après que sendDBDataToInterface soit fini
            }

    // fin

  }

initEtapeEpure() {

    // @todo, récupérer à partir de l'étude courante
    //this.setCurrentChantierByCode(TerrassorConst.CODE_CHANTIER);
// BC 09/2017 - pour le moment on rècupère à partir du chantier (@todo de l'étude s'il y en a une)
      this.setCurrentChantierByCode(TerrassorConst.chantierCode);



    // utile pour le calcul de "all Mouvements Valid"
    // this.nbMouvementsChantier = this.getNbMouvementsChantier(TerrassorConst.CURRENT_CHANTIER_ID)
    this.nbMouvementsChantier = this.getNbMouvementsChantier(TerrassorConst.chantierId) // BC 09/2017

    this.checkAllMouvementsValid()

    // restauration de l'étude en cours
    this.ApiSimu.getSimuEtude()
    .then(resultArray => {
      this.etude = resultArray.pop()
      if(this.etude) {
        this.nbJoursAtteints = this.etude.jour_atteint
        console.log('SimulatorController::etude', this.etude)
      }
    })




  this.ApiSimu.installationExists(TerrassorConst.CURRENT_ETUDE_ID)
  .then(row => {

        console.log('SimulatorController : après this.ApiSimu.installationExists : ', row)
        this.hasInstallation = (row != null)
        this.installationData = row
        this.installationValid = 0
        if (row != null) 
            this.installationValid = row.valide
  
        return this.$q.resolve(this.hasInstallation) // forcer l'update de la vue
  })
  .then(_ => {
        console.log('SimulatorController : après return this.$q.resolve(this.hasInstallation)')

    var svgcode = get_Terrassor_INTERFACE().Epure()
    this.svgEpure = svgcode //voir dans le composant schema-epure ; la définition de svgEpure rend visible le panel "Epure"

    // this.dispatchTerrassorMessages()// BC 2018/07/25 : test de déplacement de l'affichage du message après le résolve

    return this.$q.resolve(this.svgEpure) // forcer l'update de la vue
    })
  .then(_ => { // BC 2018/07/25 : test de déplacement de l'affichage du message après le résolve
        console.log('SimulatorController : après return this.$q.resolve(this.svgEpure')
    this.dispatchTerrassorMessages()

    })

  }

    /*
    * sauve analyse en cours et permet d'avancer
    */
    nouvelleEtapeVisualisations(etape = -1) {

        if (etape >= 0) {
            this.etape_epure = etape;
        }

                // on sauvegarde notre avancée
        this.ApiSimu.getSimuAnalyse()
        .then(resultArray => {
            var analyse = resultArray.pop();
            if (!analyse) {
                analyse = this.initialiserAnalyse();
            }
            analyse.mode_utilisation = this.mode_utilisation;
            analyse.etape_epure = this.etape_epure;
            analyse.etape_epure_atteinte = this.etape_epure_atteinte;

            this.ApiSimu.saveAnalyse(analyse)
            if (etape == TerrassorConst.ETAPE_SIMULATION) {
                this.initialiserSelonAnalyse(analyse);
            }
        })

    }

/*
* BC pour mise à jour de la variable régulant l'affichage des panels
* constantes utilisables
* ETAPE_EPURE_DONNEES_GENERIQUES = 0
* ETAPE_EPURE_CUBATURES = 1
* ETAPE_EPURE_MOUVEMENTS = 2
* ETAPE_SIMULATION = 4
* MODE_EPURE = 1
* MODE_EXAMEN = 2
* MODE_SIMULATEUR = 0
*/
  autoriserVisualisations() {


      // variable d'interface
    this.etapeParametrageChantierValide = false;
    this.etapeParametrageCubaturesValide = false;
    this.etapeParametrageMouvementsValide = false;
    this.editionEpureVisible = false;

    // parametrage PANELS
    this.epureVisible = true;
    //this.parametresChantierVisible = true;
    //this.parametrageChantierVisible = false;

    // parametrage HEADER
    this.chargementChantierVisible = true;
    this.chargementEtudeVisible = true
    this.chargementExamenVisible = false

      if (this.mode_utilisation != TerrassorConst.MODE_SIMULATEUR && this.etape_epure != TerrassorConst.ETAPE_SIMULATION) {

          this.epureVisible = false;

          if (this.etape_epure == TerrassorConst.ETAPE_EPURE_DONNEES_GENERIQUES) {
            this.messageChantier = TerrassorMessages.messagesChantier.init;
            }
          else {
            this.etapeParametrageChantierValide = true; // si on n'est plus à la première étape alors forcément, l'état est coché
            this.messageChantier = TerrassorMessages.messagesChantier.end;

            if (this.etape_epure == TerrassorConst.ETAPE_EPURE_CUBATURES) {
                this.etapeParametrageCubaturesValide = true;
            }
            if (this.etape_epure == TerrassorConst.ETAPE_EPURE_MOUVEMENTS) {
                this.etapeParametrageCubaturesValide = true;
                this.etapeParametrageMouvementsValide = true;
            }

            }
      }

      if (this.mode_utilisation == TerrassorConst.MODE_EXAMEN) {
          this.chargementChantierVisible = false;
          this.chargementEtudeVisible = false;
          this.chargementExamenVisible = true;
      }
      else {
        this.editionEpureVisible = true;
      }

  }

/*
* C'est le controller "global" qui gère les messages en fonction de l'avancement
*/
reinitialiserMessageCreationEpure(message=null) {

    if (message) {
        var toto = TerrassorMessages;
        this.messageCreationEpure = message;
    }
    else {
        if (this.etapeParametrageMouvementsValide) {
            this.messageCreationEpure = TerrassorMessages.messagesCreationEpure.planification;
        }
        else {
            if (this.etapeParametrageCubaturesValide) {
                this.messageCreationEpure = TerrassorMessages.messagesCreationEpure.mouvements;
            }
            else {
                this.messageCreationEpure = TerrassorMessages.messagesCreationEpure.init;
            }
        }
    }
}

/* Export de la DB pour envoyer à l'interface
*  Certaines tables non présentes en DB sont ajoutées, certaines modifiées avant envoi (simu_analyse)
*/
  sendDBDataToInterface() {

        console.log('sendDBDataToInterface')

    // lecture de ttes les données dans TerrassorDB pour l'initialisation de l'interface
    this.ApiSimu.exportAllTerrassor()
    .then(all => {

        console.log('sendDBDataToInterface : exportAllTerrassor done')
       // debugger
      
      var allTablesfromDB = all.tables

      // si, ici, les tables exo ne sont pas remplies, c'est qu'on est en mode EXAM ou CREATION EPURE et qu'en plus on est à l'étape SIMULATION
      if ((allTablesfromDB.exo_chantiers.length == 0) /* || ((this.mode_utilisation == TerrassorConst.MODE_EPURE) && (this.etape_epure == TerrassorConst.ETAPE_SIMULATION)) */ ) {
          return(this.transformerTablesSimuExoEnTablesExo(allTablesfromDB.simuexo_chantiers[0], allTablesfromDB.simuexo_cubatures, allTablesfromDB.simuexo_mouvements,                  allTablesfromDB.simuexo_mouvements_simuexo_cubatures, allTablesfromDB))
            .then(allResults => {
                this.ApiSimu.reinitAllTerrassor(all) // on a reinitialisé allTablesfromDB donc on transmets pour les lecture en "Immediate"
                this.sendDBDataToInterfaceSuite(allTablesfromDB)
            })
      }
      else {
            this.sendDBDataToInterfaceSuite(allTablesfromDB)
      }
    })
}

    /*
    *
    */
  sendDBDataToInterfaceSuite(allTablesfromDB) {
      if (TerrassorConst.chantierCode == "") { // si on a créé le chantier, son code est en base mais pas dans le chantier.js
          TerrassorConst.chantierCode = allTablesfromDB['exo_chantiers'][0].code;
      }

      // les tables suivantes ne sont pas dans la DB, mais doivent être transmises à l'interface
      // @todo voir pourquoi la table aleas n'est pas acceptée dans TerrassorDB  
      allTablesfromDB['const_enginsplus'] = this.TerrassorDB.getJsonTable("const_enginsplus")
      allTablesfromDB['const_constantes'] = this.TerrassorDB.getJsonTable("const_constantes")
      allTablesfromDB['aleas'] = this.TerrassorDB.getJsonTable("aleas")
      // @todo lire / créer une entre dans simu_etudes à partir du login elève  
      allTablesfromDB['simu_etudes'] = {"id": "1", "simu_eleves_id":"1"}

      // la table simu_analyses contient des données en JSon
      this.ApiSimu.deSerializeSimuAnalyses(allTablesfromDB['simu_analyses'])

      // appel de la mthode d'init de l'interface      
      var retour =  get_Terrassor_INTERFACE().action({"table":"all", "init":allTablesfromDB})
      
              console.log('SimulatorController::$onInit, INTERFACE init tables done', retour, allTablesfromDB)
      
      // raccourci : calculs des valeurs de cout, rendements, QSE, etc ...
      retour = Terrassor_RECALCULATE();

    // BC 2019/04 - on veut que tout soit chargé ...
    this.$timeout(() => {this.initEtapeEpure()}, 500);
  }

    /*
    *
    */
  sendDBConstToInterface() {

        console.log('sendDBConstToInterface')

    // lecture de ttes les données dans TerrassorDB pour l'initialisation de l'interface
    this.ApiSimu.exportAllTerrassor()
    .then(all => {

        console.log('sendDBConstToInterface : exportAllTerrassor done')
       // debugger

      var allTablesfromDB = all.tables

      // les tables suivantes ne sont pas dans la DB, mais doivent être transmises à l'interface
      // @todo voir pourquoi la table aleas n'est pas acceptée dans TerrassorDB
      allTablesfromDB['const_enginsplus'] = this.TerrassorDB.getJsonTable("const_enginsplus")
      allTablesfromDB['const_constantes'] = this.TerrassorDB.getJsonTable("const_constantes")
      allTablesfromDB['aleas'] = this.TerrassorDB.getJsonTable("aleas")
      // @todo lire / créer une entre dans simu_etudes à partir du login elève
      allTablesfromDB['simu_etudes'] = {"id": "1", "simu_eleves_id":"1"}

      // la table simu_analyses contient des données en JSon
      this.ApiSimu.deSerializeSimuAnalyses(allTablesfromDB['simu_analyses'])

      // appel de la mthode d'init de l'interface
      this.etude = get_Terrassor_INTERFACE().action({"table":"all", "const":allTablesfromDB})

      console.log('SimulatorController::$onInit, INTERFACE const tables done', allTablesfromDB)
    })

}

/*
*/
// Lire le chantier et mettre à jour les données dans le Panel Chantier
  setCurrentChantierByCode(code) {
    this.ApiExo.getChantierByCode(code)
    .then(results => {
        if (!results || !results.length) { // si on ne trouve pas de chantier (incohérence base et chantier_data)
            console.log('setCurrentChantierByCode : on ne trouve pas de chantier (incohérence base et chantier_data)')
            NWresetTerrassor()
            }
        else {
            this.currentChantier = results[0];       // normalement, 1 seul chantier
            this.constantesSimulateur = this.ApiConst.getConstantesSimulateur() //

            this.setPropertiesForPanelChantier();
  // this.descriptionSols = []
        }
    });
  }

setDescriptionSols(sols)
{
  this.descriptionSols = []
  if(!sols)
    return

  sols.forEach(s => {
    if (s.code != "SURF") {
        var description = {}
        description.sousTitle = s.nom
        description.items =
            [{label:"équivalence GTR", value : s.equivalencegtr},
             {label:"masse volumique", value : s.massevolumique + " t/m3"},
                {label:"coefficient de foisonnement", value : s.coeffoisonnement },
                {label:"coefficient de remplissage", value : s.coefremplissage}
            ]
        this.descriptionSols.push(description)
    }
})
}

  /*
  * Utile pour les composants enfants
  */
  getCurrentChantier() {
    return this.currentChantier

  }

  /* Utile pour déterminer si tous les mvts sont validés
  */
  getNbMouvementsChantier(chantierId) {
    //console.log('Simulator::getNbMouvementsChantier')
    var all = this.TerrassorDB.getJsonTable('exo_mouvements')
    all = all.filter(exoM => exoM.exo_chantiers_id == chantierId)
    this.nbMouvementsChantier =  (all ? all.length : 0)
    return this.nbMouvementsChantier
  }


/*
* Le mouvement courant est utilisé pour être partagés entre les cmposants enfant de <simulator>
*/
  setCurrentMouvementByCode(code, doScroll) {

    console.log('Simulator::setCurrentMouvementByCode', this.currentMouvementCode)

    if(code) {
        // this.$timeout(() => {this.currentMouvementCode = 0}, 1) // BC 12/2017 ajouté puis supprimé, je passe par le deshiniber (plus bas)
        this.$timeout(() => {this.currentMouvementCode = code}, 5)
    }

    // on scrolle vers le panel si c'est souhaité; le delai permet de s'assurer que le panel est bien présent
    if(doScroll)
      this.$timeout(() => {smoothScrollTo('panelmouvement')}, 250)

  }

/*
* Force le ré-affichage d'un mouvement; on simule le changement de mvt
*/
  refreshCurrentMouvement() {
    var code = this.currentMouvementCode
    this.setCurrentMouvementByCode('M00')
    this.$timeout(() => {
      this.setCurrentMouvementByCode(code)
      }, 500)
    
    return this.$q.resolve(this.currentMouvementCode)

  }


  /* Routines utilisées par <schema-epure> pour définir létat de certains élements SVG (cliqué, valide, etc ...)
  */
  isCurrentMouvement(code) {
      return this.currentMouvementCode == code
    }

  isCurrentCubature(code) {
      return this.currentCubatureCode == code
    }    

/* Vérifier que ce mvt est bien dans la liste des valides (liste mises à jour par checkAllMouvementsValid)
* utilisé par <schema-epure>
*/
  isMouvementValid(code) {
    var allValids = this.validMouvements
    var mvt = allValids.filter(m => {
        var exoM = m.exo_mouvements
        return exoM.code == code
      })
    return mvt.length !=0
}

    /*
    * Vérification de la validité de tous les mouvement pour pouvoir proposer de lancer l'animation
    * On stocke les mvt valides dans this.allMouvementsValid pour pouvoir  utiliser la méthode isMouvementValid
    */
    checkAllMouvementsValid() {
      //var N = this.getNbMouvementsChantier(TerrassorConst.CURRENT_CHANTIER_ID)
      var N = this.getNbMouvementsChantier(TerrassorConst.chantierId) // BC 09/2017
      if(!N)
        return false
      
console.log('checkAllMouvementsValid, nb mouvements : ', N);

      this.ApiSimu.getAllValidSimuMouvements(TerrassorConst.CURRENT_ETUDE_ID)
      .then(resultArray => {
        //console.log('Simulator::checkAllMouvementsValid', resultArray)
        this.validMouvements = resultArray

console.log('checkAllMouvementsValid, nb mouvements valides : ', this.validMouvements.length);
      
        this.allMouvementsValid = (this.validMouvements.length == N)

        if(this.allMouvementsValid == false)
          get_Terrassor_INTERFACE().etude.simu_reel = false

        this.dispatchTerrassorMessages()

        return this.$q.resolve(this.allMouvementsValid)
      })      

    }


/**
* appelée par le dashboard, lors du déroulement de l'animation. Permet de faire varier les messages de consigne lorsque un mouvmeent démarre
*/
    checkCurrentMouvementStarted(code) {
      if(this.currentMouvementCode != code) {
          return
      }

      this.currentMouvementStarted = true
      this.dispatchTerrassorMessages()

        // BC 12/2017 - si le mouvement est déjà affiché, il faut aussi le passer en Read Only !!!!
      this.inhiberMouvementStarted(code)
    }

/**
* appelée par checkCurrentMouvementStarted. Inhibe le mouvement affiché
* faire ça avec angular plutôt que jQuery
*/
    inhiberMouvementStarted(code) {
        if(this.currentMouvementCode != code)
            return

        // BC 12/2017 - si le mouvement est déjà affiché, il faut aussi le passer en Read Only !!!!
        $( ".readwrite-datepicker" ).addClass( "readonly-datepicker" );
        $( ".readwrite-datepicker" ).removeClass( "readwrite-datepicker" );
        $('.readonly-datepicker input').prop( "disabled", true);

        $( "mouvement .checkvalid" ).addClass( "disabled" );
        $( "mouvement .checkvalid input" ).prop( "disabled", true);

        $( "mouvement .tab li:last-child" ).addClass( "cacher" );

        $( "edit-echelon .new-machine" ).addClass( "disabled" );
        $( "edit-echelon .engins-list .actions" ).addClass( "disabled" );
    }

    desinhiberMouvementNotStarted() {

        if (this.currentMouvementStarted) {
                return;
        }

        // BC 12/2017 anulle les effets de l'inhiber si le mouvement n'est pas commencé !!!!
        $( ".readonly-datepicker" ).addClass( "readwrite-datepicker" );
        $( ".readonly-datepicker" ).removeClass( "readonly-datepicker" );
        $('.readwrite-datepicker input').prop( "disabled", false);

        $( "mouvement .checkvalid" ).removeClass( "disabled" );
        $( "mouvement .checkvalid input" ).prop( "disabled", false);

        $( "mouvement .tab li:last-child" ).removeClass( "cacher" );

        $( "edit-echelon .new-machine" ).removeClass( "disabled" );
        $( "edit-echelon .engins-list .actions" ).removeClass( "disabled" );
    }

/*
* Pour le "restart", définir les mouvements comme non commencés et non valides
*/
    setAllMouvementNotStarted() {

    return this.ApiSimu.getAllValidSimuMouvements(TerrassorConst.CURRENT_ETUDE_ID)      
    .then(resultArray => {
      var allPromises = []
      resultArray.forEach(elt => {
        var simu_mvt = elt.simu_mouvements
        simu_mvt.commence = false
        //simu_mvt.valide = false
        //return this.ApiSimu.saveMouvement(simu_mvt)
        var promise = this.ApiSimu.saveMouvement(simu_mvt)
        allPromises.push(promise)
      })
      return Promise.all(allPromises)
    })

  }

/*
* BC 2019/05 - définir les mouvements comme non valides : plus fait au dessus mais pas commenté :-(
*/
    setAllMouvementNotValid() {

    return this.ApiSimu.getAllValidSimuMouvements(TerrassorConst.CURRENT_ETUDE_ID)
    .then(resultArray => {
      var allPromises = []
      resultArray.forEach(elt => {
        var simu_mvt = elt.simu_mouvements
        //simu_mvt.commence = false
        simu_mvt.valide = false
        //return this.ApiSimu.saveMouvement(simu_mvt)
        var promise = this.ApiSimu.saveMouvement(simu_mvt)
        allPromises.push(promise)
      })
      return Promise.all(allPromises)
    })

  }

/*
* Invalider l'installation actuelle (et sauver en BD)
*/
  installationInvalidate() {
    this.installationValid = false
    this.installationInhib = false

    if (this.installationData) {
        this.installationData.valide = 0
      }
    return this.TerrassorDB.saveRowInTable(this.installationData, 'simu_installations')

  }
   

  /*
 * définition des propriétés qui seront rammassées par ce Panel
*/
  getTitleForPanelChantier() {
    return this.currentChantier.nom;
  }
  
/*
* formattage des propriétés du simulateur pour affichage dans le panneau supérieur
* utilisation du $filter angular (tient compte de la config i18n)
*/
    setPropertiesSimulateurForPanelChantier() {

        var s = this.constantesSimulateur
        var efficienceCompacteurs = s.efficienceCompacteurs *100;

        this.parametresSimulateur = [
            { label: "Nombre d'heures travaillées par jour", value: this.$filter('number')(s.heuresJour)},
            { label: "Largeur du chantier", value: this.$filter('number')(s.largeurChantier) + " m" },
            { label: "Prix du carburant", value: this.$filter('currency')(s.prixLitreCarburant) + '/litre'},
            { label: "CO² par litre de carburant", value: this.$filter('number')(s.kgCO2ParLitreCarburant) + ' kg'},
            { label: "Epaisseur du réglage", value: this.$filter('number')(s.epaisseurReglage) + " m" },
            { label: "Efficience compacteur", value: this.$filter('number')(efficienceCompacteurs)  + ' %'},
            { label: "Pénalités de retard", value: this.$filter('number')(s.penalitesMontant)  + ' % du budget global par jour ('+this.$filter('number')(s.penalitesPlafond)+'% max)'}
        ];


        this.setDescriptionSols(this.ApiConst.getAllSolsImmediate())
  }

/*
* formattage des propriétés du chantier pour affichage dans le panneau supérieur
* utilisation du $filter angular (tient compte de la config i18n)
*/
  setPropertiesForPanelChantier() {

   var c = this.currentChantier
   //var s = this.constantesSimulateur
   var T_interface = get_Terrassor_INTERFACE()
   var retour = T_interface.action({"table":"all", "read":{"previsionnel":"1"}});

   if (!retour.retour) {
       return;
   }
   var result = retour.objet


   //var fin = dateFns.addDays(c.debut, c.delai)
   var fin = T_interface.action({"table":"infos_dates", "chantierFinDate":""}).objet;

    this.parametresChantier = [
      { label: "Longueur", value: this.$filter('number')(c.longueur) + ' m'},
     /* { label: "Volume total", value: this.$filter('number')(result.volumeTotal) + ' m3'},*/
      { label: "Volume à extraire", value: this.$filter('number')(result.volumeTotalExtraction) + ' m3'},
      { label: "Volume à compacter", value: this.$filter('number')(result.volumeTotalCompactage) + ' m3'},
      { label: "Volume à déplacer", value: this.$filter('number')(result.volumeTotalADeplacer) + ' m3'},
      { label: "Budget", value: this.$filter('currency')(c.budget)},
      { label: "Humidité", value: this.ApiConst.getHumiditeName(c.const_humidite_id)},
      { label: "Debut", value: this.$filter('date')(c.debut, 'fullDate')},
      { label: "Délai max.", value: c.delai + " j ouvrés" },
      { label: "Fin max.", value: this.$filter('date')(fin, 'fullDate')},
      { label: "Efficience chantier", value: this.$filter('number')(c.efficience) + ' %'},
      { label: "Vitesse max.", value: this.$filter('number')(c.vitessemax) + ' km/h'},

    ];


          //this.$timeout(() => {this.$scope.$apply()}, 500);

      /* BC 2019/02 : pas la peine de rappeler ces lignes à chaque fois - c'est donc fait une fois pour toutes à l'init
      var efficienceCompacteurs = s.efficienceCompacteurs *100;

    this.parametresSimulateur = [
      { label: "Nombre d'heures travaillées par jour", value: this.$filter('number')(s.heuresJour)},
      { label: "Largeur du chantier", value: this.$filter('number')(s.largeurChantier) + " m" },
      { label: "Prix du carburant", value: this.$filter('currency')(s.prixLitreCarburant) + '/litre'},
      { label: "CO² par litre de carburant", value: this.$filter('number')(s.kgCO2ParLitreCarburant) + ' kg'},
      { label: "Epaisseur du réglage", value: this.$filter('number')(s.epaisseurReglage) + " m" },
      { label: "Efficience compacteur", value: this.$filter('number')(efficienceCompacteurs)  + ' %'},
      { label: "Pénalités de retard", value: this.$filter('number')(s.penalitesMontant)  + ' % du budget global par jour ('+this.$filter('number')(s.penalitesPlafond)+'% max)'}
    ];
*/

    console.log("SimulatorController::setPropertiesForPanelChantier, after read previsionnel all ", result);

    var coutPm3 = isNaN(result.coutParM3.valeur) ? '' : this.$filter('currency')(result.coutParM3.valeur) + '/m3'


    this.previsionnelChantier = [
    // n.b. le filtre 'currency' affiche le symbole €
      { label: "Coût Total", value: this.$filter('currency')(result.coutTotal.valeur)}, 
      { label: "Coût par m3", value: coutPm3},
      /*{ label: "Q", value: result.Q },
      { label: "S", value: result.S },
      { label: "E", value: result.E },*/
      { label: "Délai", value: result.delai + " j" },
      { label: "Date de fin", value: result.finChantier }
    ];
  }

/**
* Panneau Cubature
* Todo, sous requete sur les mouvements
*/
  setCurrentCubatureByCode(code, doScroll=0) {

    this.currentCubatureCode = code
    this.ApiExo.getCubatureByCode(code).then(cubature => {
      this.currentCubature = cubature;       // normalement, 1 seul cubature, @todo : à revoir avec sous requete

      console.log("SimulatorController::setCurrentCubatureByCode + doScroll :", this.currentCubature, doScroll);
      this.setPropertiesForPanelCubature();
          // on scrolle vers le panel si c'est souhaité; le delai permet de s'assurer que le panel est bien présent
      if(doScroll)
        this.$timeout(() => {smoothScrollTo('panelcubature')}, 250)

    });
  }

/*
* 2019 : cubature créée par l'élève
*/
  setCurrentCubature(cubature, doScroll=0) {
      this.currentCubatureCode = cubature.code
      this.currentCubature = cubature;       // normalement, 1 seul cubature, @todo : à revoir avec sous requete
      console.log("SimulatorController::setCurrentCubatureByCode + doScroll :", this.currentCubature, doScroll);
      this.setPropertiesForPanelCubature();
          // on scrolle vers le panel si c'est souhaité; le delai permet de s'assurer que le panel est bien présent
      if(doScroll) {
        this.$timeout(() => {smoothScrollTo('panelcubature')}, 250)
      }
  }

/* Données des colonnes paramètres et prévisionnel
* @todo revoir movement, couches, cubature qui doivent tenir compte des mouvements associés
*/
  setPropertiesForPanelCubature() {
   if( !this.currentCubature)
    return

   var volume = 0
   var s_couches = ''
   var leController = this
   var c = this.currentCubature
   var couches = c.cubatureCouches;
   if (typeof(couches) != 'undefined') { // si on est en mode création d'épure
       couches.forEach(couche => {
           if (!couche.purge) {
               volume += couche.volume;
           }
           var typeSol = "";
           var affSol = "";
           if (couche.const_sols_id > 0) {
               typeSol = leController.ApiExo.getTypeSolImmediate(couche.const_sols_id).nom;
               affSol = typeSol + " - " +  leController.$filter('number')(couche.volume) +  " m3";
           }
           if (!i) {
               s_couches += (s_couches == '') ? affSol : ('\n' + affSol)
           }
           i++;
       })
       this.parametresCubature = [
           { label: "PK debut", value: this.$filter('number')(c.kmdebut) + ' m'},
           { label: "PK fin", value: this.$filter('number')(c.kmfin) + ' m'},
           { label: "Cubature", value: this.$filter('number')(volume) + ' m3'},
           /*{ label: "Mouvement", value: s_group_mouvements},*/
           { label: "Couches", value: s_couches}
       ];
   }
   else { // mode SIMU
   var exo_mouvements = c.exo_mouvements
   var s_group_mouvements = ''

  var groupedMouvements = arrayGroupBy('ordre', exo_mouvements) // cf fonctions "tools addeo"
  
  // les mouvements sont groupes par ordre
  for(var key in groupedMouvements) {
    if(s_group_mouvements) 
      s_group_mouvements += ' > ' 

    var group = groupedMouvements[key]
    var s_mouvements = ''
    var i = 0;
    group.forEach(m => {
      var typeSol
      volume += m.volume
      s_mouvements +=  s_mouvements ? (' ou ' + m.code) : m.code
      typeSol = this.ApiExo.getTypeSolImmediate(m.const_sol_id).nom
      if (!i) {
        s_couches += (s_couches == '') ? typeSol : (' / ' + typeSol)
      }
      i++;
    })
    s_group_mouvements += s_mouvements
  }

  var retour = this.setPropertiesForPrevisionnelCubature(this.currentCubature)
  if (retour && retour.volumeTotal) {
      volume = retour.volumeTotal // BC 2018/09 - attention aux purges !!!!
   }

  this.parametresCubature = [
      { label: "PK debut", value: this.$filter('number')(c.kmdebut) + ' m'},
      { label: "PK fin", value: this.$filter('number')(c.kmfin) + ' m'},
      { label: "Cubature", value: this.$filter('number')(volume) + ' m3'},
      { label: "Mouvement", value: s_group_mouvements},
      { label: "Couches", value: s_couches}            
    ];
   }

  }

  /*
  *
  */
  setPropertiesForPrevisionnelCubature(cubature) {

    // colonne prévisionnel. Parfois ce n'est pas calculable, donc init à vide
    var T_interface = get_Terrassor_INTERFACE()   
    var retour, result 

    retour = T_interface.action({"table":"simu_cubatures", "read":{"code":cubature.code, "previsionnel":1}});
    // @todo retour.retour booleen seulement
    if(retour.retour == "false" || retour.retour == false) {
      // previsionnel invalide  
      this.previsionnelCubature = [
      { label: "Coût Total", value: ''}, 
      { label: "Coût par m3", value: ''},
      { label: "Rendement", value: ''}/*,
      { label: "Q", value: '' },
      { label: "S", value: '' },
      { label: "E", value: '' }*/
    ];
    return(null);
    }
    
    result = retour.objet
    console.log("SimulatorController::setPropertiesForPanelCubature, after read ", result);

    // valeur parfois indéfinie !
    var coutPm3 = isNaN(result.coutParM3.valeur) ? '' : this.$filter('currency')(result.coutParM3.valeur) + '/m3'

    this.previsionnelCubature = [
      { label: "Coût Total", value: this.$filter('currency')(result.coutTotal.valeur)}, 
      { label: "Coût par m3", value: coutPm3},
      { label: "Rendement", value: this.$filter('number')( Math.floor(0.5+result.rendement.valeur)) + ' ' + result.rendement.unite }/*,
      { label: "Q", value: result.Q },
      { label: "S", value: result.S },
      { label: "E", value: result.E }*/
    ];

    return(result);
  }

 /*
  $scope.class = "visible";
  $scope.changeClass = function(){
    if ($scope.class === "red")
      $scope.class = "blue";
    else
      $scope.class = "red";
  };
*/
    toggle(ouiNon) {
        if (ouiNon = '1') {
            return('0');
        }
        return('1');
  }
/*Mal nommée (getCubatureTitle)
*/
  getDeblaiTitle() {
    if(this.currentCubature)
      return "Cubature " + this.currentCubature.code;
    return "Cubature ..."
  }

/*
*/
  getMouvementTitle() {
    return "Mouvement " + this.currentMouvementCode;
  }


  // lecture des données du mouvement de l'exercice : code du mvt (ex : "M01"), id du chantier
  getMouvementByCode(code, id_chantier) {
    this.ApiExo.getMouvementByCode(code, id_chantier).then(data => {console.log('getMouvementByCode', data)
    });
  }


saveNbJoursAtteints(n) {
  if(this.nbJoursAtteints != n) {
    var rowData = {"id": 1, "simu_eleves_id":1, "exo_chantiers_id":TerrassorConst.chantierId, "jour_atteint":n}
    this.nbJoursAtteints = n
    return this.TerrassorDB.saveRowInTable(rowData, 'simu_etudes')
  }
}

/*
* Temporaire !!
*/
setAnalyseContent(data) {

        if(!data) {
          this.analyseContent = ''
          this.analyseBilan = ''
          this.analyseBilanSousTitreQSE = ''
          this.analyseBilanQSE = ''
          this.analyseQ = ''
          this.analyseS = ''
          this.analyseE = ''
          return;
        } 



    /*var bilanChantier = data.bilanChantier
    var bilanResultats = data.bilanResultats*/
    var retourBilan = this.lancerBILANRESUME()
    this.analyseBilan = retourBilan.html;
    this.analyseBilanSousTitreQSE = retourBilan.sousTitreQSE;
    this.analyseBilanQSE = retourBilan.QSE;
    this.analyseBilanSousTitreEchelon = retourBilan.sousTitreEchelon;


// l'analyse
        var analyse = data;
        var htmlAnalyse = "<div class='contenuPlanification'>";
        htmlAnalyse += "<span class='nb'>NB : Les erreurs sont uniquement comptabilisées à la première validation (passage). Ce nombre d'erreurs au premier passage est votre premier critère d'évaluation 'Qualité'. Le deuxième critère pris en compte est le nombre de validations nécessaires à la correction de vos échelons. Attention, toutes les erreurs détectées vous sont indiquées pour chaque passage. </span>";
        //htmlAnalyse += "<br/><b>Analyse pédagogique : </b><br/>";
        htmlAnalyse += "<ul><li>Erreurs dans la constitution des échelons : "+analyse.erreursUsage+"</li></ul>";
        htmlAnalyse += this.listerErreursTab(analyse.erreursUsageTab);
        htmlAnalyse += "<ul><li>Erreur de cohérence entre engins : "+analyse.erreursCoherence+"</li></ul>";
        htmlAnalyse += this.listerErreursTab(analyse.erreursCoherenceTab);
        htmlAnalyse += "<ul><li>Erreur dans la saisie des dates des mouvements : "+analyse.erreursDate+"</li></ul>";
        htmlAnalyse += this.listerErreursTab(analyse.erreursDateTab);
        htmlAnalyse += "<ul><li>Erreur chantier trop long : "+analyse.erreursDuree+"</li></ul>";
        htmlAnalyse += this.listerErreursTab(analyse.erreursDureeTab);
        htmlAnalyse += "<ul><li>Erreur de remblai mal dimensionné : "+analyse.erreursRemblai+"</li></ul>";
        htmlAnalyse += this.listerErreursTab(analyse.erreursRemblaiTab);
        htmlAnalyse += "<ul><li>Erreur sur engins inutiles : "+analyse.erreursInutile+"</li></ul>";
        htmlAnalyse += this.listerErreursTab(analyse.erreursInutileTab);
        htmlAnalyse += "<ul><li>Erreurs dans l'installation : "+analyse.erreursInstallation+"</li></ul>";
        htmlAnalyse += this.listerErreursTab(analyse.erreursInstallationTab);
        var corrections = analyse.passages-1;
        // htmlAnalyse += "<br/><br/>Nombre de validations nécessaires pour lancer la simulation : "+corrections+"<br/>";
    // si analyse.passages MOINS 1 (analyse.passages-1) j'imagine qu'il faut parler de correction
        htmlAnalyse += "<span class='contenuPlanificationNiv1'>Nombre de corrections nécessaires pour lancer la simulation : "+corrections+"</span>";
        htmlAnalyse += "</div>";

        this.analyseContent = htmlAnalyse
// le QSE
        this.analyseQ = data._Q
        this.analyseS = data._S
        this.analyseE = data._E

}

// temporaire !!
listerErreursTab(tabErreurs) {
        var retour = "";

        if ((typeof(tabErreurs) != 'undefined') && (tabErreurs!="")) {
            tabErreurs.forEach(e => {
                retour += "<div class='commentaire-pedago'>"
                retour += e;
                retour += "</div>";
            });
        }
     return(retour);
    }


/**
* Messages d'erreur de l'analyse; envoyés en popup et déclenche un scroll vers le panel concerné
*/
dispatchErrorMessage(errorMessage) {
  this.errorMessage = errorMessage
  if(this.errorMessage.message != '')
    this.modalDialogIsVisible = true

}


/* *
* Déplacement vers le panel concerné
*/
smoothScrollToPanel(leContexte) {
    var laData = null;
    if (leContexte.data != null)
        laData = leContexte.data
    var idPanel;
    var panel;
        // dans le cas du panel mouvementsz, il faut aussi se positionner sur le bon mouvement; or le setCurrentMvt fait déjà le scrollTo si désiré
    if(leContexte.panel == 'MOUVEMENT') {
        idPanel = 'panelmouvement';
        var doScroll = true;
        if ((typeof(laData) != "undefined") && (laData != null) && (laData)) {
            var codeMvtTab = laData.split(" ");
            var codeMvt = codeMvtTab[0]
            this.setCurrentMouvementByCode(codeMvt, doScroll)
            }
        else {
            if (_NWCheck()) {
                smoothScrollTo(idPanel);
            }
            else {
                this.controllerSmoothScrollTo(idPanel); // bug incompréhensible sous Firefox - surcharge de scrollIntoView non accessible ?
            }
        }
        laData = null;
        if (leContexte.subData != null)
            laData = leContexte.subData
        var indexEchelon = 0 // définir l'onglet courant une fois que le panel est chargé
        if ((typeof(laData) != 'undefined')  && (laData != null)  && (laData)){
            indexEchelon = laData
        }
        if (indexEchelon) {
            this.$timeout(() => {this.$scope.$broadcast('CURRENT_TAB_CHANGE', { newIndex: indexEchelon })}, 500);
        }

        this.$timeout(() => {this.$scope.$broadcast('OPENPANEL', { id: idPanel })}, 500);
    }
else {
    if(leContexte.panel == 'INSTALLATION')
        idPanel = 'panelinstallation'
    if(leContexte.panel == 'SIMULATION')
        idPanel = 'panelanimation'
    if(leContexte.panel == 'PEDAGO')
        idPanel = 'panelanalyse'
    if(leContexte.panel == 'FINANCIER')
        idPanel = 'panelbilan'
    smoothScrollTo(idPanel);
    this.$timeout(() => {this.$scope.$broadcast('OPENPANEL', { id: idPanel })}, 500)
    }
}


/*
* Définit les messages d'info ou autre selon létat de la simlation (movements valides, installation validde, animation démarée ...)
*/
dispatchTerrassorMessages(messageErreur) {

    var accesMessageInstallation = 1
    var accesMessageMouvement = 1
    var accesMessageAnimation = 1
     if (typeof(messageErreur) != 'undefined') {
         var errorMessage = new Object()
         jQuery.extend(errorMessage, messageErreur);
          errorMessage.context = messageErreur.context.panel

         accesMessageAnimation = 0
         var leMessage = errorMessage.message
         this.messageAnimation = errorMessage
         this.messageAnimation.type = "error"
         if (messageErreur.context.panel == "INSTALLATION") {
             accesMessageInstallation = 0
             this.messageInstallation = errorMessage
             this.messageInstallation.type = "error"
          /*   this.$timeout(() => {
                    angular.element('#installationMagic').triggerHandler('click'); // BC puisqu'on revient à l'installation, il faut qu'elle soit à jour !
                });
                */
         }
         if (messageErreur.context.panel == "MOUVEMENT") {
             accesMessageMouvement = 0
             this.messageMouvement = errorMessage
             this.messageMouvement.type = "error"
         }
     }

  // quand l'animation est en cours  
  if(this.allMouvementsValid && (this.installationValid || this.installationInhib) && this.animationIsPlaying) {
      this.messageEpure = TerrassorMessages.messagesEpure.running
      if (accesMessageMouvement) {
          this.messageMouvement = TerrassorMessages.messagesMouvement.running
          if(this.currentMouvementStarted)
            this.messageMouvement = TerrassorMessages.messagesMouvement.runningstarted
      }
      if (accesMessageInstallation) {
        this.messageInstallation = TerrassorMessages.messagesInstallation.running
      }
      if (accesMessageAnimation) {
        this.messageAnimation = TerrassorMessages.messagesAnimation.running
      }
      return
      }

  // quand les movement et l'installation sont valides (mais l'animation n'est pas démarrée)      
  if(this.allMouvementsValid && (this.installationValid || this.installationInhib)) {
      this.messageEpure = TerrassorMessages.messagesEpure.running
      if (accesMessageMouvement) {
          this.messageMouvement = TerrassorMessages.messagesMouvement.allvalid
      }
      if (accesMessageInstallation) {
          if (this.installationInhib) {
            this.messageInstallation = TerrassorMessages.messagesInstallation.inhib
          }
          else {
            this.messageInstallation = TerrassorMessages.messagesInstallation.allvalid
          }
      }
      if (accesMessageAnimation) {
        this.messageAnimation = TerrassorMessages.messagesAnimation.allvalid
      }
      return
      }

  // quand les mouvements sont valides, mais pas l'installation      
  if(this.allMouvementsValid && !this.installationValid) {      
      this.messageEpure = TerrassorMessages.messagesEpure.init
      if (accesMessageMouvement) {
          this.messageMouvement = TerrassorMessages.messagesMouvement.allmouvementsvalid
      }
      if (accesMessageInstallation) {
          if (this.messageInstallation && this.messageInstallation.type != "error") {
                this.messageInstallation = TerrassorMessages.messagesInstallation.init
          }
      }
      return
    }

    // quand les mouvements sont non valides (tous)
  if(!this.allMouvementsValid) {      
      this.messageEpure = TerrassorMessages.messagesEpure.init
      if (accesMessageMouvement) {
          this.messageMouvement = TerrassorMessages.messagesMouvement.init
      }
      //this.messageInstallation = TerrassorMessages.messagesInstallation.init      // sans effet car panel masqué à ce moment là
      return
    }
  
}


/*
* Forcer la visibilité d'un message
*/
toggleTerrassorMessage(context) {
  var message = null

  if(context == 'CHANTIER')
    message = this.messageChantier
  if(context == 'CREATIONEPURE')
    message = this.messageCreationEpure
  if(context == 'EPURE')
    message = this.messageEpure
  if(context == 'INSTALLATION')
    message = this.messageInstallation
  if(context == 'MOUVEMENT' )
    message = this.messageMouvement
  if(context == 'SIMULATION')
    message = this.messageAnimation

if(message) // peut être null, ex : message pour l'épure, une fois l'animation lancée
    message.visibility = !message.visibility
  
}


/*
* Copier un fichier de données dans /data/data_eleve.js, puis vider la base et relancer l'alication
* Le 'Load'
*/
importDataFile(isNW) {
    var modeExamen = false;
    var laExtension = '.terrassor';
    if (this.mode_utilisation == TerrassorConst.MODE_EXAMEN) {
        laExtension = '.terrexam';
        modeExamen = true;
    }

  if (isNW) {
    $('#ngFileDialog4TerrassorA').val('') // !! jQuery, force l'input à vide avant chaque appel
      /*
    var path = NWgetUserDataFilePath()
    path += "\\data\\etudes"
    */
    var path = this.lePathDataRep("etudes");
    $('#ngFileDialog4TerrassorA').attr('nwworkingdir', path) // on ouvre /data/chantiers par défaut
    var testREP = $('#ngFileDialog4TerrassorA').attr('nwworkingdir') // on valide en debug
    this.FileDialogA.selectFile(fileSpec => {
        console.log('importDataFile, FileDialogA', fileSpec)
        var retour = NWcopyUserDataFile(fileSpec.path, modeExamen)
    
        NWresetTerrassor() // delete de la base et reload de la page
        },
        laExtension )
    }
    else {
        this.webChargerEtude();
    }
  }

/*
* distinction MAC / PC - BC 2018/02
*/
lePathDataRep(leRep) {


    var path = NWgetUserDataFilePath();

    var isMac = process.platform; // darwin pour mac
    if (isMac === "darwin") {
        path = NWgetMacDataFilePath(leRep);
    }
    else {
        path += "\\data\\"+leRep;
    }
    return(path);
}


/* charger un chantier vide */
/* si !isNW on prend dans /data/ : chantier_data.js et eleve_data.js (qui est vide) */
/* sinon on utilise toujours eleve_data_vide.js mais on choisit un chantier dans /data/chantiers */
importDataChantier(isNW) {
    var modeExamen = false;
    if (this.mode_utilisation == TerrassorConst.MODE_EXAMEN) {
        modeExamen = true;
    }

    this.ApiSimu.importChantier = true;
  if (isNW) {
        $('#ngFileDialog4TerrassorB').val('') // !! jQuery, force l'input à vide avant chaque appel
      /*
        var path = NWgetUserDataFilePath()
        path += "\\data\\chantiers"
        */
      var path = this.lePathDataRep("chantiers");
        $('#ngFileDialog4TerrassorB').attr('nwworkingdir', path) // on ouvre /data/chantiers par défaut
        var testREP = $('#ngFileDialog4TerrassorB').attr('nwworkingdir') // on valide en debug
        this.FileDialogB.selectFile(fileSpec => {
            console.log('importDataFile, FileDialogB', fileSpec)
            var retour = NWcopyUserDataFile(fileSpec.path, modeExamen, "chantier_data.js")
            NWresetTerrassor() // delete de la base et reload de la page
        },
    '.chantierTerrassor' )
    }
else {
    this.webChargerChantiers();
    }
}


webChargerChantiers() {
    var controller=this;
    jQuery.ajax({
        type: "POST",
        url: TerrassorConst.URL_ADMIN+"/api/exo-chantiers/liste.json",
        dataType: 'json',
        success: function(res){
            console.log('Callback webChargerChantiers');
            var chantiers = res.chantier;
            controller.webAfficherListeChantiers(chantiers);
        },
        error : function(res){
            console.log('Pb Callback webChargerChantiers');
        }
    });
}


webAfficherListeChantiers(chantiers) {
    var html="";
    var section="";
    var leController = this;

    html += '<div class="container">';
    html += '<div class="refermer"></div>';
    html += '<div id="choixChantier" class="listeChoix" >';
    /*html += '<div id="choixChantier" class="listeChoix">';*/
    html += '<h2>Chantiers disponibles</h2>';
    chantiers.forEach(function(chantier, index){
        if (section != chantier.chantier_groupe) {
            html += '<span class="groupeChantier">'+chantier.chantier_groupe+'</span><br/>';
            section = chantier.chantier_groupe;
        }
//            html += '<a href="#" class="choixChantiers" onclick="propagationOK();chargerChantierId(\''+chantier.chantier_id+'_'+chantier.alea_group_id+'\');return(true);"  >'+chantier.chantier_nom+'</a><br/>';
        html += '<a href="#" class="choixChantiers '+chantier.chantier_id+'" onclick="chargerChantierId(\''+chantier.chantier_id+'_'+chantier.alea_group_id+'\');return(false);"  >'+chantier.chantier_nom+'</a>';
        html += '<span class="info '+chantier.chantier_id+'" onclick="donnerInfo(\''+chantier.chantier_id+'\')">&nbsp;</span>';
        html += '<br/>';
    });
    html += '</div>';
    html += '<div id="descriptionChantier" class="cacher">';
    chantiers.forEach(function(chantier, index){
        html += '<a href="#" class=" '+chantier.chantier_id+'" onclick="chargerChantierId(\''+chantier.chantier_id+'_'+chantier.alea_group_id+'\');return(false);"  >'
        html += '<div id="'+chantier.chantier_id+'" class="cacher">';
        html += '<span class="leNom" >'+chantier.chantier_nom+'</span>';
        html += '<span class="laDescription" >'+chantier.chantier_description+'</span>';
        html += '</div></a>';
    });
    html += '</div>';
    html += '</div>';
    //$( "#app" ).html(html);
    $( ".choixTerrassor" ).html(html);
    $( ".choixTerrassor" ).addClass( "montrer" );

    $('.refermer').on('click', function(event) {
        cacherChoix();
      });
}


/*
* Le 'Save As'
*/
traiterBugDate(laDate) {
    laDate = dateFns.addHours(laDate, 12); // décaler à 12:00 pour éviter le changement de jour lors des modifs de timezone été / hiver
    var chaineDate = JSON.stringify(laDate);
    chaineDate = chaineDate.substring(1, 11) + 'T00:00:00+00:00';
    return(new Date(chaineDate));
}

exportDataPath(path, isNW, noPopup) {


        // BC 2018/07/24 - l'analyse semble ne pas être sauvegardée quand elle le devrait ...

    var analyse = this.getAnalyseMAJ();
    this.ApiSimu.saveAnalyse(analyse)
    .then(all => {
        this.jsonDataBase(isNW).then(all => {
                this.saveDataInFile(all, path, isNW, noPopup)
            })
    })
}



jsonDataBase (isNW) {
    return this.ApiSimu.exportAllTerrassor()
        .then(all => {
            if (typeof(all.tables['simu_analyses']) != 'undefined') {
                var simuAnalyses = all.tables['simu_analyses'][0];
                if ((typeof(simuAnalyses) != 'undefined') && (typeof(simuAnalyses.date_validation) != 'undefined') && simuAnalyses.date_validation) {
                    simuAnalyses.date_validation = this.traiterBugDate(simuAnalyses.date_validation);
                }
                if ((typeof(simuAnalyses) != 'undefined') && (typeof(simuAnalyses.date_etude) != 'undefined') && simuAnalyses.date_etude) {
                    simuAnalyses.date_etude = this.traiterBugDate(simuAnalyses.date_etude);
                }
            }

        // BC 2019/04, il y a maintenant une nouvelle saisie de date (sur la création d'épure - qui est doublée dans le exo_chantiers)
            if (typeof(all.tables['simuexo_chantiers']) != 'undefined') {
                var simuexoChantiers = all.tables['simuexo_chantiers'][0];
                if ((typeof(simuexoChantiers) != 'undefined') && (typeof(simuexoChantiers.debut) != 'undefined') && simuexoChantiers.debut) {
                    simuexoChantiers.debut = this.traiterBugDate(simuexoChantiers.debut);
                    if (typeof(all.tables['exo_chantiers']) != 'undefined') {
                        var exoChantiers = all.tables['exo_chantiers'][0];
                        if ((typeof(exoChantiers) != 'undefined') && (typeof(exoChantiers.debut) != 'undefined') && exoChantiers.debut) {
                            exoChantiers.debut = this.traiterBugDate(exoChantiers.debut);
                        }
                    }
                }
            }


            if (isNW) {
                all.mode = this.mode_utilisation;
                var jsonData = JSON.stringify(all);
            }
            else {
                var jsonData = all;
            }
            return(jsonData);
        })
}

/*
* on part sur un chantier vide pour éditer une épure
*/
editerEpure(isNW) {
  var tableNames = ['simu_cubatures','simu_echelons','simu_echelons_simu_engins', 'simu_engins', 'simu_etudes',
  'simu_etudes_exo_cubatures_exo_mouvements', 'simu_installations', 'simu_installations_const_installations', 'simu_mouvements',
                    'simuexo_chantiers', 'simuexo_cubatures', 'simuexo_cubatures_couches', 'simuexo_mouvements', 'simuexo_mouvements_simuexo_cubatures',
                    'exo_chantiers', 'exo_cubatures', 'exo_mouvements', 'exo_cubatures_exo_mouvements'];

  if (isNW) {
      if (confirm("Cette action va effacer tout votre travail.\nL'avez vous enregistré au préalable ? Êtes-vous sûr de vouloir réaliser cette opération ?")) {

          this.mode_utilisation = TerrassorConst.MODE_EPURE;
          this.etape_epure =  TerrassorConst.ETAPE_EPURE_DONNEES_GENERIQUES

          return this.detruireAnalyse() // ce qui nous permet de reprendre à l'étape choisie
            .then(_ => {
                // raz de l'étude
                this.saveNbJoursAtteints(0)
                // vider les  tables "simu"
                var allPromises = []
                tableNames.forEach(t => {
                    var promise = this.TerrassorDB.truncate(t)
                    allPromises.push(promise)
                    })
                return Promise.all(allPromises)
                // quand c'est fait, on reload
                .then(_ => {
                    console.log('calling NWreloadTerrassor()')
                    NWreloadTerrassor()
                })
            })
        }
    }
    else {
        // TODO
        this.webEditerEpure();
    }

}

webEditerEpure(codes) {
    document.location.href="/#/epure";
    window.location.reload();
}

reinitParams() {


      this.analyseContent = ''
    this.analyseBilan = ''
    this.analyseBilanSousTitreQSE = ''
    this.analyseBilanQSE = ''
    this.bilanContent = ''
    this.hasInstallation = false
    this.currentMouvementStarted = false
    this.svgEpure = null
    //    this.svgEpureCreer = null
    this.errorMessage = {"context":null, "message": null}
    this.modalDialogIsVisible = false

    this.validMouvements = []
    this.allMouvementsValid = false
    this.nbMouvementsChantier =  0

    this.installationValid = false
    this.installationData = null

    this.animationIsPlaying = false

}

correctEpure() {
  if(confirm('Cette action va effacer toutes les sélections faites lors de la planification.\nÊtes-vous sûr de vouloir réaliser cette opération et reprendre votre épure ?')) {
      // BC 2019/05 - je ne trouve pas de fonction qui reinit - il doit y avoir pas mal d'autres choses à faire ... : création de reinitParams
    this.reinitParams();
      // voir dans quel ordre on appelle la ligne du dessus et celle du dessous
    this.correct(TerrassorConst.ETAPE_EPURE_CUBATURES);
  }
}

viderBaseEtRecommencer(isNW) {
  var tableNames = ['simu_analyses','simu_cubatures','simu_echelons','simu_echelons_simu_engins', 'simu_engins', 'simu_etudes',
  'simu_etudes_exo_cubatures_exo_mouvements', 'simu_installations', 'simu_installations_const_installations', 'simu_mouvements',
                    'simuexo_chantiers', 'simuexo_cubatures', 'simuexo_cubatures_couches', 'simuexo_mouvements', 'simuexo_mouvements_simuexo_cubatures',
                    'exo_chantiers', 'exo_cubatures', 'exo_mouvements', 'exo_cubatures_exo_mouvements'];

  if (isNW) {
      if (confirm("Cette action va effacer tout votre travail.\nL'avez vous enregistré au préalable ? Êtes-vous sûr de vouloir réaliser cette opération ?")) {

          // raz de l'étude
          this.saveNbJoursAtteints(0)
          // vider les  tables "simu"
          var allPromises = []
          tableNames.forEach(t => {
              var promise = this.TerrassorDB.truncate(t)
              allPromises.push(promise)
              })
          return Promise.all(allPromises)
          // quand c'est fait, on reload
          .then(_ => {
              console.log('calling NWreloadTerrassor()')
              NWreloadTerrassor()
          })
      }
  }

}

exportDataFile(isNW, noPopup) {

    var fichierDefaut = 'export.terrassor';
    var laExtension = '.terrassor';
    var toto = "toto.terrassor";
    if (this.mode_utilisation == TerrassorConst.MODE_EXAMEN) {
        fichierDefaut = 'export.terrexam';
        laExtension = '.terrexam';
        toto =  "toto.terrexam";
    }

  if (isNW) {
        $('#ngFileDialog4TerrassorC').val('') // !! jQuery, force l'input à vide avant chaque appel (bug du FileDialog et patch)
        $('#ngFileDialog4TerrassorC').removeAttr('nwsaveas') //
        /*
        var path = NWgetUserDataFilePath()
        path += "\\data\\etudes"
      */
        var path = this.lePathDataRep("etudes");
        $('#ngFileDialog4TerrassorC').attr('nwworkingdir', path) // on ouvre /data/chantiers par défaut
        var testREP = $('#ngFileDialog4TerrassorC').attr('nwworkingdir') // on valide en debug
        this.FileDialogC.saveAs(fileSpec => { // fct callback du saveAs
            console.log('exportDataFile, FileDialogC', fileSpec)
            // lecture de ttes les données dans TerrassorDB
            this.exportDataPath(fileSpec.path, isNW);
        },
    fichierDefaut,
    laExtension )
    }
    else {
        this.exportDataPath(toto, isNW, noPopup);
    }
  }


printDataFile(html) {

    if (_NWCheck()) { // Attention à la version WEB

        $('#ngFileDialog4Terrassor').val('') // !! jQuery, force l'input à vide avant chaque appel (bug du FileDialog et patch)
        $('#ngFileDialog4Terrassor').removeAttr('nwsaveas') //
        /*
        var path = NWgetUserDataFilePath()
        path += "\\data\\archives"
        */
        var path = this.lePathDataRep("archives");
        $('#ngFileDialog4Terrassor').attr('nwworkingdir', path) // on ouvre /data/archives par défaut
        var testREP = $('#ngFileDialog4Terrassor').attr('nwworkingdir') // on valide en debug
        this.FileDialog.saveAs(fileSpec => { // fct callback du saveAs
            console.log('exportHtmlFile, FileDialog', fileSpec)
            var retour = get_Terrassor_INTERFACE().archiverBILAN();
            NWwriteFile(fileSpec.path, retour)
        },
        'resume.html', '.html' )
    }
    else {
        var controller=this;

        this.$timeout(() => { // on donne le temps à Angular de faire les affichages des bilans ce qui nous permet d'en capturer le contenu dans le DOM
            var retour = get_Terrassor_INTERFACE().archiverBILAN();
            jQuery.ajax({
                type: "POST",
                url: "external/php/writeHtml.php",
                data: {"content":retour},
                dataType: 'json',
                success: function(res){
                    console.log('Callback printDataFile');
                    controller.webAfficherInfosArchive(res);
                },
                error : function(res){
                    console.log('Pb Callback printDataFile');
                }
	       });
        });
    }

}

/*
* 
*/
saveDataInFile(JsonData, fullPath, isNW, noPopup) {
    var controller=this;
    if (isNW) {
        var s = 'var eleve_data = ' + JsonData
        var retour = NWwriteFile(fullPath, s)
      }
    else {
        var eleveData = JSON.stringify(JsonData)
        jQuery.ajax({
            type: "POST",
            url: "external/php/writeFile.php",
            // data: {"content":eleveData,"codeEtude":controller.codeEtude}, // si on veut conserver le code étude
            data: {"content":eleveData}, // on ne veut pas conserver le code étude pour ne pas écraser la version précédente (prof qui donne un même code étude à plusieurs élèves)
            dataType: 'json',
            success: function(res){
               console.log('Callback saveDataInFile');
                controller.codeEtude = res.codeEtude; // on stocke le code étude pour le réutiliser à la prochaine sauvegarde
                if (!noPopup) {
                    console.log('avant  webAfficherInfosEtude');
                    controller.webAfficherInfosEtude(res);
                }
            },
            error : function(res){
               console.log('Pb Callback saveDataInFile');
            }
	   });
    }
}

webChargerEtude() {
    var html="";

    html += '<div class="container">';
    html += '<div class="refermer"></div>';
    html += '<div id="choixEtude" class="listeChoix" >';
    html += '<h2>Étude stockée en ligne</h2>';
    html += '<span><form action="/bidon.php">Saisissez votre code étude :<input type="text" name="inputEtudeName" id="inputEtude"></form>';
    html += '<a href="#" class="bouton" id="chargerEtudeId"  >Ouvrir</a></span>';
    html += '<h2>Étude stockée en local</h2>';
    html += '<span><form enctype="multipart/form-data"><input  id="webUploadEtudeFileId"  name="uploadterrassor" type="file" accept=".terrassor" /><input id="webUploadEtudeId" type="button" value="Ouvrir" /></form><progress class="cacher"></progress></span>';
    html += '</div>';
    html += '</div>';
    $( ".choixTerrassor" ).html(html);
    $( ".choixTerrassor" ).addClass( "montrer" );

    $('.refermer').on('click', function(event) {
        cacherChoix();
        return(false);
      });


    $('#chargerEtudeId').on('click', function() {
        var etudeId = document.getElementById("inputEtude").value;

        jQuery.ajax({
            type: "POST",
            url: "external/php/readFile.php?key="+etudeId, // on charge une étude - éventuellement vide
            dataType: 'json',
            success: function(res){
                if (res && res.tables && res.tables.exo_chantiers && res.tables.exo_chantiers[0]) {
                    cacherChoix();
                    document.location.href="/#/etude/"+etudeId;
                    window.location.reload();
                }
                else {
                    alert("L'étude que vous souhaitez charger n'existe pas sur notre serveur.");
                    }
                },
            error : function(res){
                alert("L'étude que vous souhaitez charger n'existe pas sur notre serveur.");
                }
            });
        return(false);
      });

    $('#webUploadEtudeId').on('click', function() {
        var file_data = $('#webUploadEtudeFileId').prop('files')[0];
        var form_data = new FormData();
        form_data.append('file', file_data);
        $( "#choixEtude progress" ).removeClass( "cacher" );
        $.ajax({
                url: 'external/php/upload.php',
                dataType: 'json',  // what to expect back from the PHP script, if anything
                cache: false,
                contentType: false,
                processData: false,
                data: form_data,
                type: 'post',
                success: function(res){
                    if (res && res.retour) {
                        if (res.retour !=  "error") {
                            cacherChoix();
                            document.location.href="/#/etude/"+res.codeEtude;
                            window.location.reload();
                        }
                        else {
                            alert("Le fichier uploadé sur le serveur n'a pu être chargé. Son format est obsolète ou le fichier est corrompu.");
                        }
                    }
                    else {
                        alert("Votre fichier n'a pu être uploadé sur le serveur.");
                    }
                },
                xhr: function() {
                    var myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                        // For handling the progress of the upload
                        myXhr.upload.addEventListener('progress', function(e) {
                            if (e.lengthComputable) {
                                $('progress').attr({
                                    value: e.loaded,
                                    max: e.total,
                                });
                            }
                        } , false);
                    }
                    return myXhr;
                }
        });
        return(false);
    });
}

webAfficherInfosEtude(infos) {

console.log('webAfficherInfosEtude infos : ', infos);

    this.codeEtude = infos.codeEtude; // on stocke le code étude pour le réutiliser à la prochaine sauvegarde

    var html="";

    html += '<div class="container">';
    html += '<div class="refermer"></div>';
    html += '<div id="choixChantier" class="listeChoix" >';
    html += '<h2>Enregistrement</h2>';
    html += "<p>Votre étude a bien été enregistrée sur notre serveur.<br/>Vous pourrez la recharger en ouvrant le lien :<br/><b>"+infos.url+"</b><br/>ou à l'aide du code <b>"+infos.codeEtude+"</b> et de la fonction 'Charger une étude'.</p>";
    html += '<p><br/>Vous pouvez également <a href="no-script.html" onclick="downloadEtudeWeb(\''+infos.fichier+'\');return(false);">télécharger la sauvegarde de votre étude en cliquant ici.</a></p>';
    html += '</div>';
    html += '</div>';
    $( ".choixTerrassor" ).html(html);
    $( ".choixTerrassor" ).addClass( "montrer" );

    $('.refermer').on('click', function(event) {
        cacherChoix();
        // 2018/03/29 - BC on recharge avec le nouveau code étude - car on ne peut pas enregistrer une étude sous son nom précédent
        document.location.href="/#/etude/"+infos.codeEtude;
        //window.location.reload();
      });
}

webAfficherInfosArchive(infos) {

    var html="";

    html += '<div class="container">';
    html += '<div class="refermer"></div>';
    html += '<div id="choixChantier" class="listeChoix" >';
    html += '<h2>Archive</h2>';
    html += '<p><br/>Vous pouvez <a href="no-script.html" onclick="downloadHtmlWeb(\''+infos.fichier+'\');return(false);">télécharger la visualisation de vos résultats en cliquant ici.</a></p>';
    html += '</div>';
    html += '</div>';
    $( ".choixTerrassor" ).html(html);
    $( ".choixTerrassor" ).addClass( "montrer" );

    $('.refermer').on('click', function(event) {
        cacherChoix();
      });
}

/*
* Promise
*/
saveTerrassorDBInFile(fullPath) {

  return this.ApiSimu.exportAllTerrassor()
  .then(all => {
      var jsonData = 'var eleve_data = ' + JSON.stringify(all)
      this.saveDataInFile(jsonData, fullPath, 1)
    })
}

/*
* export Json affiché dans un div (debug)
*/
showDatabaseContent() {
  this.ApiSimu.exportAllTerrassor()
    .then(all => {

      var jsonData = 'var eleve_data = ' + JSON.stringify(all);

      var domObj = angular.element('#DBContent')
      domObj.append(jsonData)
      
    })
}

  /* 
  * recharge la page
  */
  reloadTerrassor() {
    return NWreloadTerrassor()
  }


    // BC 2019/04
  getAnalyseMAJ() {
    var etude = get_Terrassor_INTERFACE().etude;
    var analyse = etude.analyse;
     if (typeof(analyse) != 'undefined') {
          analyse.mode_utilisation = this.mode_utilisation
          analyse.etape_epure = this.etape_epure
          analyse.etape_epure_atteinte = this.etape_epure_atteinte
      }
      return(analyse);
  }


    // BC 2019/04
  detruireAnalyse(numEtape=-1) {

      var retour =  get_Terrassor_INTERFACE().action({"table":"simu_analyses", "init":[]})
      return this.ApiSimu.deleteAnalyse(TerrassorConst.CURRENT_ETUDE_ID)
        .then(_ => {
          var analyse = this.getAnalyseMAJ();
          if (numEtape >= 0) {
              analyse.etape_epure = numEtape;
          }
          return this.ApiSimu.saveAnalyse(analyse);
        })
  }

/*
* Les mouvements deviennent R/W et ont fait une sauvegarde horodatée des données eleve
* Les mouvements sont invalidés, donc masquage de l'anim et du Tdb
* Changement 2017.08.01; les mouvements valides rtestent valides, mais non démarrés. Seule l'installation est invalidée
*/
correct(numEtape = -1) {
    var controller=this;
          // NB : on ne met pas simu_analyses dans tableNames car on passe par detruireAnalyse
  var tableNames = [/*'simu_analyses'*/,'simu_cubatures','simu_echelons','simu_echelons_simu_engins', 'simu_engins', 'simu_etudes',
  'simu_etudes_exo_cubatures_exo_mouvements', 'simu_installations', 'simu_installations_const_installations', 'simu_mouvements']

    if (_NWCheck()) { // Attention à la version WEB

        // constr. fichier temporaire de sauvegarde auto.
        var fullPath = NWgetUserTempDataFilePath()

        return this.saveTerrassorDBInFile(fullPath)
            .then(_ => this.setAllMouvementNotStarted()) // mvts non commencés donc modifiables (Promise)
            .then(_ => {      // pour la mise à jour du schema epure
                console.log("setAllMouvementNotStarted Done")
                return this.checkAllMouvementsValid()
            })
            .then(_ => {    // annuler l'analyse pedagogique pour l'étude actuelle
                return this.detruireAnalyse(numEtape)
            })
            .then(_ => {
            //invalider l'installation 2017.008.01
            this.installationInvalidate()
            })
            .then(_ => {
            if (numEtape > 0) {
                // vider les  tables "simu" 2019/05
                var allPromises = []
                tableNames.forEach(t => {
                    var promise = this.TerrassorDB.truncate(t)
                    allPromises.push(promise)
                    })
                return Promise.all(allPromises)
                .then(_ => {
                    console.log('calling NWreloadTerrassor() a')
                    NWreloadTerrassor()
                    })
                }
            else {
                console.log('calling NWreloadTerrassor() b')
                NWreloadTerrassor()
            }
        })
    }
    else { // BC 2018/02 VERSION WEB - on ne passe plus par un rechargement de la page (NWreloadTerrassor) mais juste par un "rafraichissement" de l'install commandé par la zone cachée "installationMagic"
        this.exportDataFile(0, "noPopup");
        alert("Votre étude a été sauvegardée sur notre serveur. Vous pouvez la retrouver dans son état précédent - avant correction -  sous le code : "+this.codeEtude);
        // this.codeEtude =""; // on change d'étude

        return this.setAllMouvementNotStarted() // mvts non commencés donc modifiables (Promise)
            .then(_ => {      // pour la mise à jour du schema epure
                console.log("setAllMouvementNotStarted Done")
            if (numEtape > 0) {
                return this.setAllMouvementNotValid()
                }
            else {
                return this.checkAllMouvementsValid()
                }
            })
            .then(_ => {    // annuler l'analyse pedagogique pour l'étude actuelle
                console.log("correct avant detruireAnalyse")
                return this.detruireAnalyse(numEtape)
            })
            .then(lAnalyse => {
            console.log("correct numEtape : ", numEtape)
                if (numEtape > 0) {
                    // vider les  tables "simu" 2019/05
                    var allPromises = []
                    tableNames.forEach(t => {
                        var promise = this.TerrassorDB.truncate(t)
                        allPromises.push(promise)
                        })
                    return Promise.all(allPromises)
                    .then(_ => {
                        console.log("correct avant initialiserSelonAnalyse")
                        controller.initialiserSelonAnalyse(lAnalyse);
                         })
                    }
                else {
                    this.saveNbJoursAtteints(0)
                    get_Terrassor_INTERFACE().etude.jourAtteint = 0
                    this.animationIsPlaying = false
                    this.$timeout(() => {
                        angular.element('#installationMagic').triggerHandler('click');
                        angular.element('#mouvementMagic').triggerHandler('click');
                    });
                }
            })
    }
}

  installFinInhib() {

      // ici, on ne DOIT pas avoir un nbPassagesIntallation à 1 ou plus - si c'est le cas ça n'est pas bon car le "bouton" ne devrait alors pas être activé
      // du coup, on ne touche pas à l'analyse (éventuellement, on la sauve)
/*
        // BC l'analyse n'est plus valide
      var retour =  get_Terrassor_INTERFACE().action({"table":"simu_analyses", "topDateEtude":[]})
      this.ApiSimu.saveAnalyse(retour.objet)
*/
    // on sauve l'analyse
    var analyse = this.getAnalyseMAJ();
    if (typeof(analyse) != 'undefined') {
        analyse.inhibe = 0;
        analyse.passagesInstallation  = 0; // c'est normalement déjà le cas ...
        this.ApiSimu.saveAnalyse(analyse);
    }
      // il faut aussi que (!AnimationController.isPlaying)"


       // et on repart de 0
      this.saveNbJoursAtteints(0)

      if (_NWCheck()) { // Attention à la version WEB


        get_Terrassor_INTERFACE().etude.jourAtteint = 0;
        var analyse = this.getAnalyseMAJ();
        this.ApiSimu.saveAnalyse(analyse);

        // constr. fichier temporaire de sauvegarde auto.
        var fullPath = NWgetUserTempDataFilePath()

        return this.saveTerrassorDBInFile(fullPath)
     /*       .then(_ => this.setAllMouvementNotStarted()) // mvts non commencés donc modifiables (Promise)*/
            .then(_ => {      // pour la mise à jour du schema epure
                console.log("setAllMouvementNotStarted Done")
                return this.checkAllMouvementsValid()
            })
/*        .then(_ => {
            //invalider l'installation 2017.008.01
            this.installationInvalidate()
            })
            */
        .then(_ => {
            NWreloadTerrassor()
        })
    }
    else {
//        return this.checkAllMouvementsValid()
//        .then(_ => {
            // this.saveNbJoursAtteints(0)
            get_Terrassor_INTERFACE().etude.jourAtteint = 0
            this.animationIsPlaying = false
            this.installationInhib = false
            this.$timeout(() => {
                angular.element('#installationMagic').triggerHandler('click');
                angular.element('#mouvementMagic').triggerHandler('click');
            });
  //      })
    }
  }

/*
* @todo filtrer sur l'étude courante
*/
  reset(numEtape = -1) {

      // NB : on ne met pas simu_analyses dans tableNames car on passe par detruireAnalyse
  var tableNames = [/*'simu_analyses'*/,'simu_cubatures','simu_echelons','simu_echelons_simu_engins', 'simu_engins', 'simu_etudes',
  'simu_etudes_exo_cubatures_exo_mouvements', 'simu_installations', 'simu_installations_const_installations', /*'simu_installations_const_equipementsprestations', */
  'simu_mouvements']

    if (_NWCheck()) { // Attention à la version WEB

        return this.detruireAnalyse(numEtape) // ce qui nous permet de reprendre à l'étape choisie
            .then(_ => {
                var fullPath = ''

                // constr. fichier temporaire de sauvegarde auto.
                var fullPath = NWgetUserTempDataFilePath()

                // copier les données de la bse
                return this.saveTerrassorDBInFile(fullPath)
                    .then(json => {
                        // raz de l'étude
                        this.saveNbJoursAtteints(0)
                        // vider les  tables "simu"
                        var allPromises = []
                        tableNames.forEach(t => {
                            var promise = this.TerrassorDB.truncate(t)
                            allPromises.push(promise)
                        })
                        return Promise.all(allPromises)
                    })
                    // quand c'est fait, on reload
                    .then(_ => {
                        console.log('calling NWreloadTerrassor()')
                        NWreloadTerrassor()
                    })
                })
          }
    else { // BC 2018/02 VERSION WEB - on ne passe plus par un rechargement de la page (NWreloadTerrassor) mais juste par un "rafraichissement" de l'install commandé par la zone cachée "installationMagic"
        this.exportDataFile(0, "noPopup");
        alert("Votre étude a été sauvegardée sur notre serveur. Vous pouvez la retrouver dans son état précédent - avant reprise -  sous le code : "+this.codeEtude);
        //this.codeEtude =""; // on change d'étude
        chargerChantierId(TerrassorConst.chantierId+"_"+TerrassorConst.alea_group_id);
    }
}

controllerSmoothScrollTo(eltId) {
    //var e = document.getElementById(eltId)
    var ae = angular.element('#'+eltId);
    if(ae) {
      //ae[0].scrollIntoView({behavior:'smooth'});
      ae[0].scrollIntoView(top);
    }
  }

    doOnCheckParametrageChantierValid(forceValue) {

        if (forceValue !== undefined) { // can bue true | false
            if (forceValue == this.etapeParametrageChantierValide) { // on force, mais rien ne change
                return;
            }
            this.etapeParametrageChantierValide = forceValue;
        }

        // si on décoche, on est (ou on revient) à la première étape : les données génériques
        if (!this.etapeParametrageChantierValide) {
            this.messageChantier = TerrassorMessages.messagesChantier.init;
            // this.etape_epure = TerrassorConst.ETAPE_EPURE_DONNEES_GENERIQUES;
            this.nouvelleEtapeVisualisations(TerrassorConst.ETAPE_EPURE_DONNEES_GENERIQUES);
        }
        else {
            if (this.validerParametrageChantier()) { // si on coche on valide que la saisie est OK
                //this.etape_epure = TerrassorConst.ETAPE_EPURE_CUBATURES;
                this.nouvelleEtapeVisualisations(TerrassorConst.ETAPE_EPURE_DONNEES_GENERIQUES_OK);
                this.etape_epure_atteinte = Math.max(this.etape_epure_atteinte, this.etape_epure);
                this.messageChantier = TerrassorMessages.messagesChantier.end;
                this.messageCreationEpure = TerrassorMessages.messagesCreationEpure.init;

            }
            else {
                this.etapeParametrageChantierValide = false; // on ne peut pas cocher
            }
        }
    }

    initialiserAnalyse() {
        // init "bidon" pour autoriser l'enregistrement en bd
        var analyses = new Object();
        analyses.mode_utilisation = 0;
        analyses.etape_epure = 0;
        analyses.etape_epure_atteinte = 0;
        analyses.simu_etudes_id = 1;
        analyses.passages = 0;
        analyses.erreursCoherence = 0;
        analyses.erreursUsage = 0;
        analyses.erreursInutile = 0;
        analyses.erreursRemblai = 0;
        analyses.erreursDate = 0;
        analyses.erreursDuree = 0;
        analyses.erreursInstallation = 0;
        analyses.erreursCoherenceTab=[];
        analyses.erreursUsageTab=[];
        analyses.erreursInutileTab=[];
        analyses.erreursRemblaiTab=[];
        analyses.erreursDateTab=[];
        analyses.erreursDureeTab=[];
        analyses.erreursInstallationTab=[];
        analyses.passagesInstallation = 0;
        analyses.bonusQ = 0;
        analyses.tabBonusQualiteMouvements=[];
        analyses.installationQ = 0;
        analyses.installationQMax = 0;
        analyses.tabBonusInstallationQ=[];
        analyses.installationS = 0;
        analyses.installationSMax = 0;
        analyses.tabBonusInstallationS=[];
        analyses.installationE = 0;
        analyses.installationEMax = 0;
        analyses.tabBonusInstallationE=[];
        analyses.installationInhib = 0;
        return(analyses);
    }

    // y-a-t-il des règles à respecter ?
    validerParametrageChantier() {
        return(true)
    }



    /*
    * pour génération des tables EXO à partir des tables SIMUEXO
    */
    creerExoMouvement(simuExoMouvement) {
        var exoMouvement = {};
        exoMouvement.id = simuExoMouvement.id;
        exoMouvement.nom = simuExoMouvement.nom;
        exoMouvement.code = simuExoMouvement.code;
        exoMouvement.exo_chantiers_id = simuExoMouvement.exo_chantiers_id;
        exoMouvement.exo_cubatures_depart_id = simuExoMouvement.simuexo_cubatures_depart_id;
        exoMouvement.exo_cubatures_arrivee_id = simuExoMouvement.simuexo_cubatures_arrivee_id;
        exoMouvement.volume = simuExoMouvement.volume;
        exoMouvement.distance = simuExoMouvement.distance;
        exoMouvement.const_sol_id = simuExoMouvement.const_sol_id;
        exoMouvement.preparationtraitementdemande = simuExoMouvement.preparationtraitementdemande;
        exoMouvement.transformationdemandee = simuExoMouvement.transformationdemandee;
        exoMouvement.stopautoavant = simuExoMouvement.stopautoavant;
        exoMouvement.stopautoapres = simuExoMouvement.stopautoapres;
        exoMouvement.reglage = simuExoMouvement.reglage;
        exoMouvement.description = simuExoMouvement.description;
        return(exoMouvement);
    }

    /*
    * pour génération des tables EXO à partir des tables SIMUEXO
    */
    creerExoCubatureExoMouvement(simuExoMouvementExoCubature) {
        var exoMouvementExoCubature = {};
        exoMouvementExoCubature.id = simuExoMouvementExoCubature.id;
        exoMouvementExoCubature.exo_cubatures_id = simuExoMouvementExoCubature.simuexo_cubatures_id;
        exoMouvementExoCubature.exo_mouvements_id = simuExoMouvementExoCubature.simuexo_mouvements_id;
        exoMouvementExoCubature.sens_inverse = simuExoMouvementExoCubature.sens_inverse;
        exoMouvementExoCubature.ordre = simuExoMouvementExoCubature.ordre;
        return(exoMouvementExoCubature);
    }

    /*
    * On génère les tables EXO à partir des tables SIMUEXO
    * si allTablesfromDB est passé en paramètre, on le rempli avec les tables EXO nouvellement crées
    */
    transformerTablesSimuExoEnTablesExo(leChantier, lesCubatures, lesMouvements, lesMouvementsCubatures, allTablesfromDB = null) {

        var leController = this;
        // on commence par vider les tables exos (c'est probablement inutile car elles doivent être vides ...)
        var tableNames = ['exo_chantiers','exo_cubatures','exo_mouvements','exo_cubatures_exo_mouvements'];
        // vider les  tables "exo"
        var allPromisesTEXO = [];
        tableNames.forEach(t => {
            var promise = this.TerrassorDB.truncate(t)
            allPromisesTEXO.push(promise)
            })
            return Promise.all(allPromisesTEXO)
            // quand c'est fait, on reload
            .then(_ => {


                // 1- on met à jour le chantier
            return leController.ApiSimu.saveExoChantier(leChantier)
                .then(chantier => {
                    if (allTablesfromDB) {
                        allTablesfromDB.exo_chantiers[0] = chantier;
                    }
                    var allPromises = [];
                // 2- les cubatures
                    lesCubatures.forEach(item => {
                        if (item.description == "") {
                            item.description = " ";
                        }
                        var promise = leController.ApiSimu.saveExoCubatures(item);
                        allPromises.push(promise)
                    });
                    return Promise.all(allPromises)
                        .then(allResults => {
                            if (allTablesfromDB) {
                                allTablesfromDB.exo_cubatures = allResults;
                            }
                            var allPromisesMouvements = [];
                        // 3- les mouvements
                            lesMouvements.forEach(itemMouvement => {
                                var exoMouvement = leController.creerExoMouvement(itemMouvement);
                                var promiseMouvement = leController.ApiSimu.saveExoMouvements(exoMouvement);
                                allPromisesMouvements.push(promiseMouvement)
                            });
                            return Promise.all(allPromisesMouvements)
                                .then(allResultsMouvements => {
                                    if (allTablesfromDB) {
                                        allTablesfromDB.exo_mouvements = allResultsMouvements;
                                    }
                                    var allPromisesMouvementsCubatures = [];
                                // 4- les cubaturesMouvements
                                    var cptCubaturesMouvements = 0;
                                    lesMouvementsCubatures.forEach(itemCubatureMouvement => {
                                    var exoMouvementExoCubature = leController.creerExoCubatureExoMouvement(itemCubatureMouvement);
                                    if (allTablesfromDB) {
                                        allTablesfromDB.exo_cubatures_exo_mouvements[cptCubaturesMouvements] = exoMouvementExoCubature;
                                        cptCubaturesMouvements ++;
                                    }
                                    var CubatureMouvement = leController.ApiSimu.saveExoMouvementsCubatures(exoMouvementExoCubature);
                                    allPromisesMouvementsCubatures.push(CubatureMouvement)
                                    });
                                    return Promise.all(allPromisesMouvementsCubatures)
                                })
                        })
                })
            })
    }




// ----------------------- end class
}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/simulator.controller.js